<ng-car-load
  *ngIf="(store$ | async) as store"
  [loading]="store.state.loading"
  [trafficHistory]="store.state.trafficHistory"
  (reload)="dispatchLoadResults()">
</ng-car-load>
